import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faTag,
  faChevronDown,
  faChevronUp,
} from "@fortawesome/free-solid-svg-icons";
import { AVAILABLE_TAGS } from "@/constants/tagConstants.js";

// Constants
const TOP_TAGS = AVAILABLE_TAGS.slice(0, 4); // Show first 4 tags by default

const TagsFilter = ({
  selectedTag,
  handleTagSelect,
  showAllTags,
  setShowAllTags,
  savePageState,
  t,
}) => {
  const displayedTags = showAllTags ? AVAILABLE_TAGS : TOP_TAGS;

  return (
    <div className="mb-6">
      <div className="flex items-center gap-2 mb-2">
        <FontAwesomeIcon icon={faTag} className="text-gray-500" />
        <h2 className="text-md font-semibold">{t("explore.filter_by_tag")}</h2>
      </div>
      <div className="flex flex-wrap gap-2">
        {displayedTags.map((tag) => (
          <button
            key={tag}
            onClick={() => handleTagSelect(tag)}
            className={`px-3 py-1.5 rounded-full text-sm transition-all duration-200 ${
              selectedTag === tag
                ? "bg-primary-500 text-white shadow-md scale-105 hover:bg-primary-600 dark:bg-gray-700 dark:text-gray-400"
                : "bg-gray-100 text-gray-700 hover:bg-gray-200 dark:bg-gray-800 dark:text-gray-400"
            }`}
          >
            {t(`tags.labels.${tag}`)}
          </button>
        ))}
        {AVAILABLE_TAGS.length > 4 && (
          <button
            onClick={() => {
              setShowAllTags(!showAllTags);
              // Save state when showing/hiding all tags
              savePageState();
            }}
            className="text-primary-500 hover:text-primary-600 text-sm flex items-center gap-1"
          >
            {showAllTags ? (
              <>
                {t("explore.show_less")} <FontAwesomeIcon icon={faChevronUp} />
              </>
            ) : (
              <>
                {t("explore.show_more")}{" "}
                <FontAwesomeIcon icon={faChevronDown} />
              </>
            )}
          </button>
        )}
        {selectedTag && (
          <button
            onClick={() => handleTagSelect(selectedTag)}
            className="text-gray-500 hover:text-gray-700 text-sm"
          >
            {t("explore.clear_filter")}
          </button>
        )}
      </div>
    </div>
  );
};

export default TagsFilter;
